import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../../http';
import { toApiError } from '../utils';
import type { ManagementPlanDTO } from './useGetManagementPlans';
import type { ManagementPlanPayload } from './useCreateManagementPlan';

export const useUpdateManagementPlan = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({
			planId,
			...payload
		}: ManagementPlanPayload & { planId: string }) => {
			try {
				const { data } = await api.put<ManagementPlanDTO>(
					`/management/plan/update/${planId}`,
					payload
				);
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao atualizar plano');
			}
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['management-plans'] });
			queryClient.invalidateQueries({ queryKey: ['management-plan'] });
		},
	});
};
